import clsx from "clsx";
import GlobalLoadingIndicator from "components/common/GlobalLoadingIndicator";
import NavigationContext from "context/NavigationContext";
import React, { Suspense } from "react";
import { Spinner } from "react-bootstrap";
import { matchRoutes, renderRoutes } from "react-router-config";
import { Switch, withRouter } from "react-router-dom";
import routes from "../../dashboard-configs/routesConfig";
import Header from "./components/Header/Header";
import RightSidebar from "./components/RightSidebar/RightSidebar";
import "./Layout.scss";

const handleDrawerResponsive = () => {
  if (window.innerWidth < 900) {
    return false;
  }

  return true;
};

const Layout = (props) => {
  const [openDrawer, setOpenDrawer] = React.useState(() =>
    handleDrawerResponsive()
  );
  const [isDrawerClose, setIsDrawerClose] = React.useState(() =>
    handleDrawerResponsive()
  );
  let config = {};

  const matched = matchRoutes(routes, props.location.pathname)[0];
  if (matched && matched.route.settings) {
    config = matched.route.settings.layout.config;
  }

  const checkHeader =
    config.header && !config.header.display ? null : (
      <Header
        disableMenu={config?.rightSidebar?.display === false}
        konjExit={config?.header?.konjExit}
        showBack={config?.header?.showBack}
        title={config.title || matched.route.title}
      />
    );
  const checkRightSidebar =
    config.rightSidebar && !config.rightSidebar.display ? null : (
      <RightSidebar />
    );
  // const checkFooter =
  //   config.footer && !config.footer.display ? null : <Footer />;

  React.useEffect(() => {
    window.addEventListener("resize", resizeChecker);

    return () => {
      window.addEventListener("resize", resizeChecker);
    };
  }, []);

  const resizeChecker = () => {
    if (handleDrawerResponsive()) {
      setOpenDrawer(true);
      setIsDrawerClose(true);
    } else {
      setOpenDrawer(false);
      setIsDrawerClose(false);
    }
  };

  const handleDrawerToggle = () => {
    setOpenDrawer(!openDrawer);
    if (!openDrawer && !handleDrawerResponsive()) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  };

  return (
    <NavigationContext.Provider
      value={{
        openDrawer,
        handleDrawerToggle,
        isDrawerClose,
      }}
    >
      <GlobalLoadingIndicator />
      {config && checkHeader}
      <div
        className={clsx(
          "d-flex relative",
          config && !config.header && "cu-layout"
        )}
        onClick={(e) => {
          e.stopPropagation();
          if (openDrawer && !isDrawerClose) {
            handleDrawerToggle();
          }
        }}
      >
        {config && checkRightSidebar}
        <Suspense
          fallback={
            <div className="cu-center">
              <Spinner animation="border" variant="primary" />
            </div>
          }
        >
          <Switch>{renderRoutes(routes)}</Switch>
        </Suspense>
      </div>
      {/* {config && checkFooter} */}
    </NavigationContext.Provider>
  );
};

export default withRouter(Layout);
